import {useState} from "react";
import {useUpdateIntervention} from "../../../hooks/useInterventions";
import {userRoleList} from "../../../utils/constants";
import {proposalDate} from "../../../utils/date";
import CancelModal from "./cancelModal";
import ReportModal from "./ReportModal";
import RefuseModal from "./refuseModal";

const RecapReport = ({intervention, role}) => {
  const {onUpdateIntervention} = useUpdateIntervention();
  const [cancelModal, setCancelModal] = useState(false);
  const [refuseModal, setRefuseModal] = useState(false);
  const [reportModal, setReportModal] = useState(false);

  const AcceptReport = () => {
    onUpdateIntervention({
      id: intervention?.id,
      body:
        role === userRoleList.CLIENT
          ? {reported_byClient: true}
          : {reported_byTech: true},
    });
  };
  return (
    <>
      <CancelModal
        openModal={cancelModal}
        toggleModal={setCancelModal}
        intervention={intervention}
      />
      <RefuseModal
        openModal={refuseModal}
        toggleModal={setRefuseModal}
        intervention={intervention}
        role={role}
      />

      <ReportModal
        openModal={reportModal}
        toggleModal={setReportModal}
        intervention={intervention}
        initialValues={{
          date: !!intervention?.startDate
            ? new Date(intervention?.startDate).toISOString().split("T")[0]
            : "",
          time: !!intervention?.startDate
            ? new Date(intervention?.startDate)
                .toTimeString()
                .split(":")
                .slice(0, 2)
                .join(":")
            : "",
        }}
        role={role}
      />
      <div className="w-full flex flex-col gap-4 justify-start items-start h-fit bg-white rounded-xl p-4">
        <div className="text-[#19295C] font-semibold text-lg mt-2 ">
          Demande de report de rendez vous{" "}
        </div>
        <div className="flex flex-col justify-start items-start gap-2">
          <div>Nouvelle date:</div>
          <div className="flex items-center gap-2 justify-start text-[#7e7e7e]">
            <span className="text-lg text-[#1A64B9] ">
              <i className="fi fi-rr-time-watch-calendar flex items-center"></i>
            </span>
            {proposalDate(intervention?.startDate)}
          </div>
        </div>

        {(role === userRoleList.CLIENT && !!intervention?.reported_byTech) ||
        (role === userRoleList.TECHNICIAN &&
          !!intervention?.reported_byClient) ? (
          <div className="w-full grid grid-cols-2 items-center gap-2">
            <button
              onClick={() => setRefuseModal(true)}
              type="button"
              className={`!rounded-md  !py-[11px] !px-3 bg-white !text-[#0D44B1] !border-[#0D44B1] !border font-medium text-sm   uppercase `}
            >
              Refuser
            </button>
            <button
              // onClick={() => setReportModal(true)}
              onClick={AcceptReport}
              className=" !py-3 !px-3  !rounded-md text-sm  gap-3 uppercase font-semibold flex justify-center items-center bg-gradient-to-r  from-[#0022AA] to-[#1A64B9] text-white "
            >
              Accepter{" "}
            </button>
          </div>
        ) : (
          <div className="w-full grid grid-cols-2 items-center gap-2">
            <button
              onClick={() => setCancelModal(true)}
              type="button"
              className={`!rounded-md  !py-[11px] !px-3 bg-white !text-[#0D44B1] !border-[#0D44B1] !border font-medium text-sm   uppercase `}
            >
              Annuler
            </button>
            <button
              onClick={() => setReportModal(true)}
              className=" !py-3 !px-3  !rounded-md text-sm  gap-3 uppercase font-semibold flex justify-center items-center bg-gradient-to-r  from-[#0022AA] to-[#1A64B9] text-white "
            >
              Modifier{" "}
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default RecapReport;
